"use client";

import { useEffect, useState } from "react";

export const useGeolocationPermission = (): PermissionState => {
  const [permission, setPermission] = useState<PermissionState>("prompt");

  useEffect(() => {
    if (typeof navigator === "undefined" || !navigator.permissions) {
      return;
    }

    let permissionStatus: PermissionStatus | undefined;
    let isMounted = true;

    const handlePermissionChange = () => {
      if (permissionStatus && isMounted) {
        setPermission(permissionStatus.state);
      }
    };

    void navigator.permissions
      .query({ name: "geolocation" })
      .then((status) => {
        if (!isMounted) {
          return;
        }

        permissionStatus = status;
        setPermission(status.state);
        status.addEventListener("change", handlePermissionChange);
      })
      .catch(() => {
        // Keep the location option available when the Permissions API
        // cannot report geolocation state.
      });

    return () => {
      isMounted = false;
      permissionStatus?.removeEventListener("change", handlePermissionChange);
    };
  }, []);

  return permission;
};
